import config from "../../config"
import RequestService from "../RequestService"

const fetchWaivers = (successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrlV2}/waivers`, successCallback, failureCallback)
}

export default fetchWaivers;